// test1493
(1493 && 0);
